import { ManageAccountInvitesPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/manage/account-invites/'].update({
        staticData: { title: { page: 'AccountInvites.PageHeading' } },
        component: authGuard(ManageAccountInvitesPage, { isWhitelabel: true, canInviteAccounts: true })
    });
};
